import styles from '@ui/components/Breadcrumbs/Breadcrumbs.module.scss';
import FontAwesomeProIcon from '@ui/components/FontAwesomeProIcon/FontAwesomeProIcon';
import Link from '@ui/components/Link/Link';
import React, { Children } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { VisuallyHidden } from '@ariakit/react';

const SingleBreadcrumbItem = ({ isCurrent = false, to, children }) => (
  <li
    className={classNames(styles.singleItem, {
      [styles.current]: isCurrent,
    })}
  >
    <Link
      aria-current={isCurrent ? 'page' : null}
      className={styles.singleLink}
      to={to}
    >
      <FontAwesomeProIcon
        aria-hidden="true"
        className={styles.singleIcon}
        icon="chevron-left"
        role="presentation"
      />
      {children}
    </Link>
  </li>
);

const BreadcrumbItem = ({ isCurrent = false, to, children }) => (
  <li
    className={classNames(styles.item, {
      [styles.current]: isCurrent,
    })}
  >
    <Link
      aria-current={isCurrent ? 'page' : null}
      className={styles.link}
      to={to}
    >
      {children}
    </Link>
  </li>
);

const Breadcrumbs = ({
  children,
  theme = 'default',
  showItemsCount = 2,
  className,
  ...props
}) => {
  const renderItem = (item, showSeparator) => (
    <>
      {item}
      {showSeparator && (
        <span className={styles.seperator}>
          <FontAwesomeProIcon
            aria-hidden="true"
            className={styles.icon}
            icon="chevron-right"
            role="presentation"
          />
        </span>
      )}
    </>
  );

  return (
    <nav
      aria-label="Positionsanzeige Navigation"
      className={classNames(styles[theme], className)}
      {...props}
    >
      <ol className={styles.list}>
        {Children.map(children, (child, index) =>
          index < children.length - showItemsCount ? (
            <VisuallyHidden>{renderItem(child, false)}</VisuallyHidden>
          ) : (
            renderItem(child, index < children.length - 1)
          ),
        )}
      </ol>
    </nav>
  );
};

Breadcrumbs.propTypes = {
  showItemsCount: PropTypes.number,
  theme: PropTypes.oneOf(['default', 'contrast', 'secondary']),
};

export default Breadcrumbs;
export { BreadcrumbItem, SingleBreadcrumbItem };
